import * as requestFromServer from "./menuCrud";
import { menuSlice, callTypes } from "./menuSlice";

const { actions } = menuSlice;

export const fetchFaqsMenu = (queryParams) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  try {
    let { data } = await requestFromServer.findFaqs({
      filter: queryParams?.filter,
      pageNumber: parseInt(queryParams?.pageNumber ?? 1) - 1,
      pageSize: 9999,
    });

    if (queryParams?.filter != null) {
      let obj = {
        module: queryParams.filter.module[0],
        items: data?.items ?? [],
      };

      dispatch(actions.faqsFetched(obj));
    }
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't find faqs";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};

export const fetchVideosMenu = (queryParams) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  try {
    let { data } = await requestFromServer.findVideos({
      filter: queryParams?.filter,
      pageNumber: parseInt(queryParams?.pageNumber ?? 1) - 1,
      pageSize: 9999,
    });

    if (queryParams?.filter != null) {
      let obj = {
        module: queryParams.filter.module[0],
        items: data?.items ?? [],
      };

      dispatch(actions.videosFetched(obj));
    }
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't find faqs";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};

export const fetchManualsMenu = (queryParams) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  try {
    let { data } = await requestFromServer.findManuals({
      filter: queryParams?.filter,
      pageNumber: parseInt(queryParams?.pageNumber ?? 1) - 1,
      pageSize: 9999,
    });

    if (queryParams?.filter != null) {
      let obj = {
        module: queryParams.filter.module[0],
        items: data?.items ?? [],
      };

      dispatch(actions.manualsFetched(obj));
    }
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't find faqs";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};

export const fetchUpdatesMenu = (queryParams) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  try {
    let { data } = await requestFromServer.findUpdates({
      filter: queryParams?.filter,
      pageNumber: parseInt(queryParams?.pageNumber ?? 1) - 1,
      pageSize: 9999,
    });

    if (queryParams?.filter != null) {
      let obj = {
        module: queryParams.filter.module[0],
        items: data?.items ?? [],
      };

      dispatch(actions.updatesFetched(obj));
    }
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't find faqs";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};

export const fetchLinksMenu = (queryParams) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  try {
    let { data } = await requestFromServer.findLinks({
      filter: queryParams?.filter,
      pageNumber: parseInt(queryParams?.pageNumber ?? 1) - 1,
      pageSize: 9999,
    });

    if (queryParams?.filter != null) {
      let obj = {
        module: queryParams.filter.module[0],
        items: data?.items ?? [],
      };

      dispatch(actions.linksFetched(obj));
    }
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't find faqs";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};

export const fetchNewsletterMenu = (queryParams) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  try {
    let { data } = await requestFromServer.findNewsletter({
      filter: queryParams?.filter,
      pageNumber: parseInt(queryParams?.pageNumber ?? 1) - 1,
      pageSize: 9999,
    });

    if (queryParams?.filter != null) {
      let obj = {
        module: queryParams.filter.module[0],
        items: data?.items ?? [],
      };

      dispatch(actions.newslettersFetched(obj));
    }
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't find faqs";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};

export const setFaqOpenedProductMenu = (productIds, moduleId) => async (dispatch) => {
  try {
    dispatch(actions.setFaqOpenedProductMenu({productIds, moduleId}));
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't set menu";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};
export const setVideosOpenedProductMenu = (productIds, moduleId) => async (dispatch) => {
  try {
    dispatch(actions.setVideosOpenedProductMenu({productIds, moduleId}));
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't set menu";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};
export const setManualsOpenedProductMenu = (productIds, moduleId) => async (dispatch) => {
  try {
    dispatch(actions.setManualsOpenedProductMenu({productIds, moduleId}));
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't set menu";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};
export const setUpdatesOpenedProductMenu = (productIds, moduleId) => async (dispatch) => {
  try {
    dispatch(actions.setUpdatesOpenedProductMenu({productIds, moduleId}));
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't set menu";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};
export const setLinksOpenedProductMenu = (productIds, moduleId) => async (dispatch) => {
  try {
    dispatch(actions.setLinksOpenedProductMenu({productIds, moduleId}));
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't set menu";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};
export const setNewslettersOpenedProductMenu = (productIds, moduleId) => async (
  dispatch
) => {
  try {
    dispatch(actions.setNewslettersOpenedProductMenu({productIds, moduleId}));
  } catch (error) {
    console.error(error);
    error.clientMessage = "Can't set menu";
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  }
};
